import ApiUtil from './api';
import { AuthProviders } from 'mewe/constants';

class Api extends ApiUtil {

  loginWithCode(params) {
    return this.post('/auth/login/code', {
      data: params,
      non401: true,
    }, 'apiRoot3');
  }

  loginWithPassword(params) {
    return this.post('/auth/login', {
      data: params,
      contentType: 'application/x-www-form-urlencoded',
      non401: true,
    }, 'apiRoot3');
  }

  loginWithToken(provider, params) {
    return this.post(`/auth/login/token/${provider}`, {
      data: params,
      non401: true,
    }, 'apiRoot3');
  }

  checkUserByToken(provider, params) {
    return this.post(`/auth/check/user/token/${provider}`, {
      data: params,
      non401: true,
    });
  }

  checkEmailAvailability(email) {
    return this.get('/auth/checkEmail?email=' + encodeURIComponent(email.toLowerCase()));
  }

  validatePhone(params) {
    return this.post('/validation/phone/send', {
      data: JSON.stringify(params),
    });
  }

  resendConfirmationLink(email) {
    return this.post('/me/sendvalidation', {
      data: JSON.stringify({ email: email }),
    });
  }

  registerAccount(params, authProvider) {
    let url = (authProvider === AuthProviders.MEWE) ? '/auth/register' : `/auth/register/token/${authProvider}`;
    return this.post(url, { data: JSON.stringify(params) }, 'apiRoot3');
  }

  checkAccountByEmail(email) {
    return this.post(`/auth/check/user/email`, { data: JSON.stringify({ email }) });
  }

  checkAccountByPhone(countryCode, phone) {
    return this.post(`/auth/check/user/phone`, { data: JSON.stringify({ countryCode, phone }) });
  }

  getRegistrationSmsCode(params) {
    return this.post(`/validation/phone/create`, { data: JSON.stringify(params) });
  }

  getRegistrationEmailCode(params) {
    params.locale = document.documentElement.lang || 'en';
    return this.post(`/validation/email/send`, { data: JSON.stringify(params) });
  }

  getLoginSmsCode(params) {
    return this.post(`/validation/phone/login/send`, { data: JSON.stringify(params) });
  }

  getLoginEmailCode(params) {
    return this.post(`/validation/email/login/send`, { data: JSON.stringify(params) });
  }

  sendPasswordResetEmail(params) {
    return this.post('/api/v2/auth/send-reset-email', {
      data: JSON.stringify(params),
      non401: true,
    });
  }

  sendPasswordResetCode(params) {
    return this.post('/api/v2/auth/reset-pass', {
      data: JSON.stringify(params),
      non401: true,
    });
  }

  getRegistrationInfo() {
    return this.get(`/registration/info`);
  }

}

export default new Api();
